import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingProprietary } from './pages/LandingProprietary';
import { Architecture } from './pages/Architecture';
import { HowItWorks } from './pages/HowItWorks';
import { Economics } from './pages/Economics';
import { Platform } from './pages/Platform';
import { Runtime } from './pages/Runtime';
import { Factory } from './pages/Factory';
import { Trial } from './pages/Trial';
import { QuickStart } from './pages/QuickStart';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { DesignPartner } from './pages/DesignPartner';
import { Pricing } from './pages/Pricing';
import { Security } from './pages/Security';
import { Comparison } from './pages/Comparison';
import { Pitch } from './pages/Pitch';
import { Sovereign } from './pages/Sovereign';
import './index.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingProprietary />} />
        <Route path="/architecture" element={<Architecture />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/economics" element={<Economics />} />
        <Route path="/runtime" element={<Runtime />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/factory" element={<Factory />} />
        <Route path="/trial" element={<Trial />} />
        <Route path="/docs" element={<QuickStart />} />
        <Route path="/docs/quick-start" element={<QuickStart />} />
        <Route path="/design-partner" element={<DesignPartner />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/security" element={<Security />} />
        <Route path="/compare" element={<Comparison />} />
        <Route path="/pitch" element={<Pitch />} />
        <Route path="/sovereign" element={<Sovereign />} />
        <Route path="*" element={<LandingProprietary />} />
      </Routes>
    </Router>
  );
}

export default App;
